import Service from "./Service";
import {
  HotelDisposePolicyEntity,
  ExtraInfoEntity,
  PolicyInfoEntity,
  ProductInfoEntity,
  ProductInfoSearchModel,
  WhereModel,
  SpecInfoEntity,
  ThrowInfoEntity,
  PriceEntity,
  ValidateModel,
} from "@/model/HotelPolicy";
import { PageList } from "@/model/system";
import { OrderEntity } from "@/model/Order";
class HotelPolicyService extends Service {
  getProductLists(data: any) {
    return this.post<PageList<any>>(`/Product/list`, data, { failTips: false });
  }
  getIHotelList(data: any) {
    return this.post<PageList<any>>(`/IHotelPolicy/IHotelList`, data);
  }
  getProductInfo(data: ProductInfoEntity) {
    return this.post<ProductInfoEntity>(`/HotelPolicy/ProductInfo`, data);
  }
  IHotelInfo(data: any) {
    return this.post<any>(`/IHotelPolicy/IHotelInfo`, data);
  }
  getProductDetail(data: any) {
    return this.post<ProductInfoEntity>(`/Product/ProductDetail`, data);
  }
  Citylist(id: any) {
    return this.get<any>(`/HotelPolicy/Citylist/${id}`);
  }
  //获取酒店特色、设施
  getThemeFacilityList(data: any) {
    return this.post<PageList<any>>(`/product/SearchFacilities?filterCode=${data}`, {});
  }
  //获取商圈
  getCityBusiness(data: any) {
    return this.post<any>("/product/CityBusiness", data);
  }
  getKeyword(data: any) {
    return this.post<any>("/product/ComplateKeyword", data);
  }

  productVerify(data: ValidateModel) {
    return this.post<any>(`/product/ProductVerify`, data);
  }
}
export default new HotelPolicyService("hotelpolicy");
